import React from "react";
import ComponentEditor from "../../../../components/component-editor";

const MixComponents = ({ item, onChange, disableButtons }) => {
  return <ComponentEditor item={item?.components} onChange={components => onChange('components', components)} disableButtons={disableButtons} />
}

export default MixComponents;
